import { render, staticRenderFns } from "./ReviewReports.vue?vue&type=template&id=27b76f9c&scoped=true&"
import script from "./ReviewReports.vue?vue&type=script&lang=js&"
export * from "./ReviewReports.vue?vue&type=script&lang=js&"
import style0 from "./ReviewReports.vue?vue&type=style&index=0&id=27b76f9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b76f9c",
  null
  
)

export default component.exports